import { Skeleton } from "@/components/ui/skeleton";
import { sanitizeCSSVarName } from "components/helpers";
import { getCommonPinningStyles } from "components/BaseTableV3/BaseTableV3";
import {
  BODY_CELL_CLASSES,
  BODY_ROW_CLASSES,
} from "components/BaseTableV3/tableClasses";

const MAX_SKELETON_ROWS = 10;

// Sized like BaseTableV3Cell so the placeholder columns line up with the header.
const getCellStyle = column =>
  column.getIsPinned()
    ? getCommonPinningStyles(column)
    : {
        width: `calc(var(${sanitizeCSSVarName(`--col-${column.id}-size`)}) * 1px)`,
      };

export function BaseTableV3SkeletonBody({ table }) {
  const columns = table.getVisibleLeafColumns();
  const rowCount = Math.min(
    table.getState().pagination.pageSize,
    MAX_SKELETON_ROWS
  );

  return (
    <tbody aria-busy="true" aria-label="Loading">
      {Array.from({ length: rowCount }, (_, rowIndex) => (
        <tr
          key={rowIndex}
          data-slot="skeleton-row"
          className={BODY_ROW_CLASSES}
        >
          {columns.map(column => (
            <td
              key={column.id}
              style={getCellStyle(column)}
              className={BODY_CELL_CLASSES}
            >
              <Skeleton className="tw:h-4 tw:w-full" />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
}
